import { createSelector } from '@reduxjs/toolkit';

const userSelect = (state) => state.user;

const userDeviceIdSelect = (user) => user.device_id;

const userSlice = {
  /**
   * @type {import('@reduxjs/toolkit').Selector<import('store').RootState, string>}
   */
  deviceId: createSelector(userSelect, userDeviceIdSelect),
};

export default userSlice;
